import CenterWrap from 'components/CenterWrap';
import React from 'react';
import { Link } from 'react-router-dom';

import { LAST_UPDATED_LABEL, legalDocumentList } from './content';
import {
  IndexCard,
  IndexDescription,
  IndexGrid,
  IndexWrap,
  Meta,
} from './styles';

export default function TermsIndex() {
  return (
    <CenterWrap>
      <IndexWrap>
        <h1>Documentos Legais</h1>
        <p>
          Esta página centraliza os termos de uso e as políticas de privacidade
          da ClickLav para clientes e parceiros.
        </p>
        <Meta>Última atualização: {LAST_UPDATED_LABEL}</Meta>

        <IndexGrid>
          {legalDocumentList.map(document => (
            <IndexCard key={document.path} to={document.path}>
              <span className="eyebrow">{document.audience}</span>
              <h2>{document.title}</h2>
              <IndexDescription>{document.description}</IndexDescription>
              <span className="action">Abrir documento</span>
            </IndexCard>
          ))}
        </IndexGrid>

        <p>
          Se preferir voltar para a página principal, acesse{' '}
          <Link to="/">o site da ClickLav</Link>.
        </p>
      </IndexWrap>
    </CenterWrap>
  );
}
